import { render } from "./EmploymentDrilldownModal.vue?vue&type=template&id=21c88b66&scoped=true"
import script from "./EmploymentDrilldownModal.vue?vue&type=script&lang=js"
export * from "./EmploymentDrilldownModal.vue?vue&type=script&lang=js"

import "./EmploymentDrilldownModal.vue?vue&type=style&index=0&id=21c88b66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21c88b66"

export default script